import PageHeading from "admin/components/PageHeading";
import ShowCategory from "admin/GenreCategory/ShowCategory";
import ShowGenre from "admin/GenreCategory/ShowGenre";
import useFetchCategories from "api/CategoryResource/useFetchCategories";
import useGenres from "api/GenreResource/useGenres";
import AdminPageLoader from "components/AdminPageLoader";
import Admin2 from "layouts/Admin2";
import { useState } from "react";
import { BsBookmarks, BsSearch } from "react-icons/bs";
import AddCategory from "admin/GenreCategory/AddCategory";
import AddGenre from "admin/GenreCategory/AddGenre";

const Categories = () => {
	const { data: genres, isLoading: isLoadingGenres } = useGenres("yes");
	const { data: categories, isLoading: isLoadingCategories } = useFetchCategories("yes");

	const [searchCollection, setsearchCollection] = useState("");
	const [searchCategory, setsearchCategory] = useState("");

	if (isLoadingGenres || isLoadingCategories) {
		return <AdminPageLoader />;
	}

	return (
		<Admin2 fullWidth>
			<div className="max-w-7xl mx-auto px-4 py-6 w-full">
				<div className="flex justify-between items-center mb-8">
					<PageHeading
						title="Categories & Collections"
						icon={<BsBookmarks size={20} className="text-gray-600" />}
					/>
					<div className="flex gap-3">
						<AddCategory />
						<AddGenre />
					</div>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{/* Categories Section */}
					<div className="bg-white rounded-lg border border-gray-100">
						<div className="p-4 border-b border-gray-50">
							<div className="flex items-center justify-between">
								<h2 className="text-lg font-medium text-gray-700">Categories</h2>
								<span className="text-sm text-gray-400">{categories?.data?.length || 0}</span>
							</div>
						</div>

						<div className="p-4">
							<div className="relative mb-4">
								<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
									<BsSearch className="text-gray-300" size={14} />
								</div>
								<input
									type="text"
									placeholder="Search categories..."
									value={searchCategory}
									onChange={(e) => setsearchCategory(e.target.value)}
									className="pl-9 w-full p-2 text-sm border border-gray-100 rounded-md focus:ring-1 focus:ring-akgreen focus:border-akgreen outline-none transition-all bg-gray-50"
								/>
							</div>

							<div className="space-y-1 max-h-[500px] overflow-y-auto pr-1">
								{categories?.data
									?.filter((category) => {
										if (!searchCategory) return true;
										return category.name.toLowerCase().includes(searchCategory.toLowerCase());
									})
									?.map((category) => (
										<ShowCategory
											key={category.id}
											categoryName={category?.name}
											booksCount={category?.books_count}
											categoryId={category?.id}
										/>
									))}
								{(!categories?.data?.length ||
									categories?.data?.filter((category) =>
										category.name.toLowerCase().includes(searchCategory.toLowerCase()),
									).length === 0) && (
									<div className="text-center py-6 text-sm text-gray-400">No categories found</div>
								)}
							</div>
						</div>
					</div>

					{/* Collections Section */}
					<div className="bg-white rounded-lg border border-gray-100">
						<div className="p-4 border-b border-gray-50">
							<div className="flex items-center justify-between">
								<h2 className="text-lg font-medium text-gray-700">Collections</h2>
								<span className="text-sm text-gray-400">{genres?.data?.data?.length || 0}</span>
							</div>
						</div>

						<div className="p-4">
							<div className="relative mb-4">
								<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
									<BsSearch className="text-gray-300" size={14} />
								</div>
								<input
									type="text"
									placeholder="Search collections..."
									value={searchCollection}
									onChange={(e) => setsearchCollection(e.target.value)}
									className="pl-9 w-full p-2 text-sm border border-gray-100 rounded-md focus:ring-1 focus:ring-akgreen focus:border-akgreen outline-none transition-all bg-gray-50"
								/>
							</div>

							<div className="space-y-1 max-h-[500px] overflow-y-auto pr-1">
								{genres?.data?.data
									?.filter((genre) => {
										if (!searchCollection) return true;
										return genre.name.toLowerCase().includes(searchCollection.toLowerCase());
									})
									?.map((genre) => (
										<ShowGenre
											key={genre.id}
											genreName={genre?.name}
											genreId={genre?.id}
											booksCount={genre?.books_count}
										/>
									))}
								{(!genres?.data?.data?.length ||
									genres?.data?.data?.filter((genre) =>
										genre.name.toLowerCase().includes(searchCollection.toLowerCase()),
									).length === 0) && (
									<div className="text-center py-6 text-sm text-gray-400">No collections found</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Admin2>
	);
};

export default Categories;
